export default __webpack_public_path__ + "static/media/esophagus_plot_female.cd88c9d9.png";